import { axios } from "@/utils"

export default {
    getEventBySlug(slug) {
        return axios.get(`/v1/events/?slug=${slug}`)
    },

    listCalendarEvents(slug) {
        return axios.get(`/v1/events/calendar/`)
    },

    getLiveEvent(params = null) {
        if (params !== null) {
            return axios.get(`/v1/events/live/`, {params: params} )
        } else {
            return axios.get(`/v1/events/live/`)
        }
    },

    createCheckin(picacode, source = null, tags = null, domain = null) {
        let payload = {
            picacode,
            platform: 'site',
            domain: domain,
        }
        if (source) payload['source'] = source
        if (tags) payload['tags'] = tags
        return axios.post(`/v2/checkins/`, payload)
    },

    saveCheckinOption(picacode, source = null, tags = null, option = null) {
        let payload = {
            picacode,
            platform: 'site'
        }
        if (source) payload['source'] = source
        if (tags) payload['tags'] = tags
        if (option) payload['option'] = option
        return axios.post(`/v2/checkins/`, payload)
    },

    uploadSelfie(checkinId, payload) {
        return axios.post(`/v2/checkins/${checkinId}/add-face/`, payload)
    },

    validateStay(checkinId, payload) {
        return axios.post(`/v2/checkins/${checkinId}/validate-stay/`, payload)
    },

    completeCheckin(token, payload= {platform: 'site'}, contentType= 'application/json') {
        return axios.post(`/v2/complete-checkin/${token}/`,
            payload,
            { headers: {'Content-Type': contentType} })
    },

    removeCheckin(checkinId) {
        return axios.delete(`/v2/checkins/${checkinId}/`)
    },

    getCheckins(params) {
        return axios.get(`/v3/checkins/`, {params})
    },
    getCheckinPhotos(checkinId, params) {
        return axios.get(`/v3/checkins/${checkinId}/medias/`, {params})
    },

    getCheckin(checkinId) {
        return axios.get(`/v2/checkins/${checkinId}/`, {params: {expand_pica_service: true, include_photos_summary: true}})
    },

    downloadAlbum(checkinId, gallerySelection = null) {
        let payload
        if (Array.isArray(gallerySelection)) {
            if (gallerySelection.length > 0) {
                payload = { gallery_ids: gallerySelection }
            }
        } else if (gallerySelection != null) {
            payload = { gallery_ids: [gallerySelection] }
        }
        return axios.post(`/v2/checkins/${checkinId}/download-medias/`, payload)
    },

    anonymizeAlbum(checkinId) {
        return axios.post(`/v2/checkins/${checkinId}/anonymize/`)
    },

    deAnonymizeAlbum(checkinId) {
        return axios.post(`/v2/checkins/${checkinId}/deanonymize/`)
    },

    getCheckinDetail(picacode, params={}) {
        return axios.get(`/v3/checkins/by-code/${picacode}/`, {params})
    },

    hideMedia(mediaId) {
        return axios.post(`/v3/medias/${mediaId}/hide/`)
    },

    /**
     * Returns the photos that belongs to the player; { picacode: "<code>", photos: [...]  }
     * @param params Object of key-value params; { pica_service: <ID>, ep: "<JWT TOKEN>" }
     */
    getPreviewPhotos(params) {
        return axios.get(`/v2/photos-preview/`, {params: params} )
    },

    getFaceInferenceStatus(checkinId) {
        return axios.get(`/v3/checkins/${checkinId}/face-inference-status/`)
    },

    startFaceInference(checkinId) {
        return axios.post(`/v3/checkins/${checkinId}/face-inference/`)
    }
}
